import { createTheme } from "@mui/material/styles";

// Visual Studio Dark Theme
const vsDarkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#1e1e1e",
      paper: "#252526",
    },
    primary: {
      main: "#569cd6",
    },
    secondary: {
      main: "#d7ba7d",
    },
    text: {
      primary: "#d4d4d4",
      secondary: "#9cdcfe"
    },
    string: {
      main: "#ce9178"
    },
    comment: {
      main: "#6a9955"
    },
    keyword: {
      main: "#c586c0"
    },
    symbol: {
      main: "#d4d4d4"
    }
  },
  typography: {
    fontFamily: "'Fira Code', monospace",
  },
});

export default vsDarkTheme;
